import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Modal from "../../modal";
import React, { useEffect, useRef, useState } from "react";
import { ErrorMessage } from "./error-message";

export const ValidationModal = ({ validation, finishTask }) => {
    const [isModalOpen, setModalOpen] = useState(false);
    const confirmButtonRef = useRef(null);
    const {
        overridableErrors,
        attributeValueLogicalErrors,
        overridableErrorCustomHeader = "Attention: Product has one or more potential data-validation issues or values that conflict with each other.",
    } = validation;

    useEffect(() => {
        if (validation.isValidationConfirmationActive) {
            setModalOpen(true);
        }
    }, [validation.isValidationConfirmationActive, validation.attributeValueLogicalErrors]);

    const handleConfirm = () => {
        if (confirmButtonRef.current) {
            confirmButtonRef.current.disabled = true;
        }

        setModalOpen(false);
        finishTask(true);
    };

    return (
        <Modal
            show={isModalOpen}
            onClose={() => setModalOpen(false)}
        >
            <h2>
                <FontAwesomeIcon
                    className="m-r-12 txt-error-light"
                    icon={faExclamationTriangle}
                />
                {overridableErrorCustomHeader}
            </h2>

            {attributeValueLogicalErrors.map(({ parentAttributeName, attributeName, errors }, index) => {
                return errors.map((error, innerIndex) => {
                    return (
                        <ErrorMessage
                            key={`${error}_${index}_${innerIndex}`}
                            parentAttributeName={parentAttributeName}
                            attributeName={attributeName}
                            error={error}
                        />
                    );
                });
            })}
            {overridableErrors.map((error, index) => {
                return (
                    <ErrorMessage
                        key={`${error}_${index}`}
                        error={error}
                    />
                );
            })}

            {overridableErrors.length === 0 && <p>Are you sure you want to proceed?</p>}

            <div className="button-group m-t-16 justify-content-center">
                <button
                    className="button"
                    onClick={() => setModalOpen(false)}
                >
                    Cancel
                </button>
                <button
                    ref={confirmButtonRef}
                    type="submit"
                    className="button -primary"
                    onClick={handleConfirm}
                >
                    Confirm
                </button>
            </div>
        </Modal>
    );
};
